import s from "../productCardV3.module.css";

const ServiceTypeBadge = (props) => {
    // Destructured props
    const {
        product,
        labelBadgeColor,
        formattedHref
    } = props;

    if (!product.productLabel) {
        return null;
    }

    return (
        <div
            className={`${s.serviceType} ${s[labelBadgeColor]} dark:bg-contrast-yellow`}
            data-testid={`product-card-badge-container-${formattedHref}`}
        >
            <p
                data-testid={`product-card-badge-${formattedHref}`}
                className={"dark:text-black"}
            >
                {product.productLabel}
            </p>
        </div>
    )
}

export default ServiceTypeBadge;
